<template>
  <div>
    <header class="header">
      <div class="top">
        <div class="logo">
          <img src="../assets/img/logo1.png" class="img" alt="招商基金" />
          <!-- <img src="../assets/img/logo2.png" class="img" alt="投资者" /> -->
        </div>
        <div class="search" @click="$router.push({ path: '/search' })"></div>
      </div>
      <ul class="nav">
        <li>
          <router-link to="/" class="a">首 页</router-link>
        </li>
        <li
          v-for="(item, index) in navList"
          :key="item.id"
          @click="
            oneIndex = index
            getList(item.id)
          "
        >
          <router-link :to="'/licai?id=' + item.id + '&index=' + index" class="a"> {{ item.name }}</router-link>
        </li>
      </ul>
    </header>
    <ul class="act_list">
      <li v-for="item in datas" :key="item.id">
        <a :href="item.url">
          <img :src="item.file" alt="" class="img" />
          <div class="title">
            <span>{{ item.name }}</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      datas: '',
      navList: [],
    }
  },
  created() {
    this.id = this.getQueryValue('id')
    this.getBannerChild()
    this.getNav()
  },
  methods: {
    async getBannerChild() {
      const res = await this.axios.get(`/index/bannerChild?id=${this.id}`)
      console.log(res)
      if (res.code === 1) {
        this.datas = res.data
      }
    },
    async getNav() {
      const res = await this.axios.get('/index/tabs')
      if (res.code === 1) {
        this.navList = res.data
      }
    },
  },
}
</script>

<style scoped lang="less">
.header {
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: -0.6rem;
  .top {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 0 0.3rem;
    background: #fff;
    .logo {
      display: flex;
      height: 1rem;
      align-items: center;
      .img {
        max-height: 0.46rem;
        margin-right: 0.4rem;
      }
    }
    .search {
      width: 1rem;
      height: 1rem;
      background: url(../assets/img/search.png) no-repeat center center;
      background-size: 0.41rem;
    }
  }
  .nav {
    width: 100%;
    background: url(../assets/img/bg_01.png) no-repeat left top;
    background-size: 100% 100%;
    height: 0.96rem;
    line-height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    li {
      padding: 0;
      margin: 0;
      width: 50%;
      text-align: center;
      height: 0.96rem;
      display: flex;
    }
    .a {
      width: 100%;
      color: #fff;
      font-size: 0.28rem;
      height: 0.8rem;
      display: inline-block;
      line-height: 0.8rem;
      position: relative;
      &.sel {
        font-weight: bold;
        background: url(../assets/img/bg_02.png) no-repeat center 85%;
        background-size: auto 0.02rem;
      }
    }
  }
}
.act_list {
  width: 95%;
  margin: auto;
  margin-top: 30px;
  li {
    margin-bottom: 0.2rem;
    width: 100%;
    overflow: hidden;
    border-radius: 6px;
    position: relative;
    box-shadow: -2px 0.2rem 0.2rem 0px rgba(245, 219, 204, 0.74);
    .img {
      width: 100%;
      display: block;
    }
    .title {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      color: #fff;
      line-height: 0.6rem;
      font-weight: bold;
      span {
        text-shadow: 0.03rem 0.03rem 0.07rem rgba(40, 39, 40, 0.34);
        font-size: 0.52rem;
      }
    }
  }
}
</style>
